var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_182400",
    "data-name": "Group 182400",
    transform: "translate(-1101 -128)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "download_724933",
    transform: "translate(1090 132)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_182392",
    "data-name": "Group 182392",
    transform: "translate(19.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_182391",
    "data-name": "Group 182391",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49753",
    "data-name": "Path 49753",
    d: "M135.993,7.33a.5.5,0,0,0-.457-.294h-2.01V.5a.5.5,0,0,0-.5-.5h-2.01a.5.5,0,0,0-.5.5V7.035H128.5a.5.5,0,0,0-.378.833l3.518,4.02a.5.5,0,0,0,.756,0l3.518-4.02A.5.5,0,0,0,135.993,7.33Z",
    transform: "translate(-127.998 0)",
    fill: "#4169E1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_182394",
    "data-name": "Group 182394",
    transform: "translate(16 10.975)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_182393",
    "data-name": "Group 182393"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49754",
    "data-name": "Path 49754",
    d: "M29,352v3.015H18V352H16v4.02a1,1,0,0,0,1,1.005H30a1,1,0,0,0,1-1.005V352Z",
    transform: "translate(-16 -352)",
    fill: "#4169E1"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149784",
    "data-name": "Rectangle 149784",
    width: 24,
    height: 24,
    transform: "translate(1101 128)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.7dd5f16d8ceec59c91abcb72e5f4195d.svg";
export { ForwardRef as ReactComponent };